import { ModelSetTransformer, ModelTransformer } from '../common/common.model';
import { ExtRole } from '../common/common.service';

export interface RoleItem {
    id: number;
    initials: string;
    shortName: string;
    name: string;
}

class RoleModelTransformer implements ModelTransformer<RoleItem, ExtRole> {
    transform(model: ExtRole): RoleItem {
        return {
            id: model.id,
            initials: model.text.initials,
            shortName: model.text.shortName,
            name: model.text.name,
        };
    }
}

export class RoleModelSetTransformer extends ModelSetTransformer<
    RoleItem,
    ExtRole
> {
    protected newTransformer(): ModelTransformer<RoleItem, ExtRole> {
        return new RoleModelTransformer();
    }
}
